<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Entry -->
        <!-- <b-col
          cols="6"
          md="9"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('globalActions.findCode')"
            />
          </div>
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              @click="SearchData(searchQuery)"
            > Cari
            </b-button>
          </div>
        </b-col> -->
      </b-row>
    </div>


    <b-table
      id="refListTable"
      ref="refListTable"
      no-provider-paging
      no-provider-filtering
      :fields="tableColumns"
      :items="itemLists"
      responsive
      primary-key="id"
      show-empty
      :busy="isBusy"
      :empty-text="$t('globalSingular.noMatching')"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
          <div class="text mb-1">
            <b-spinner class="align-middle"/>
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
        </div>
      </template>

      <template #head()="{ field }">
        <table-search-column
          :field="field"
          :fields="tableColumns"
          :focused-field="focusedSearchField"
          @set-focused-field="(value) => focusedSearchField = value"
          @search-data="(params) => searchData(params)"
        />
      </template>

      <template #cell(code)="data">
        <b-link
          :to="{ name: 'apps-transactions-cash-advance-request-approval-detail', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          {{ data.item.code }}
        </b-link>
      </template>

      <template #cell(date)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.date }}
        </span>
      </template>

      <template #cell(purpose_date)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.purpose_date }}
        </span>
      </template>

      <template #cell(unit)="{ item }">
        <span class="font-weight-bold d-block text-nowrap" v-if="item.getWorkUnit">
          {{ item.getWorkUnit.name }}
        </span>
        <span v-else> - </span>
      </template>

      <template #cell(request_amount)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <template #cell(audit)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
        {{ item.updated_process }}  By {{ item.getUser.user_name }}
        </span>
        <small class="font-italic">{{ new Date(item.updated_at).toDateString() }}</small>
      </template>

    </b-table>


    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            aria-controls="refInvoiceListTable"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>

      </b-row>
    </div>

  </b-card>
</template>


<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BPagination,
  BSpinner,
} from 'bootstrap-vue'
import TableSearchColumn from "@/components/TableSearchColumn.vue"

// import useList from './useList'
import useListTablePage from '@/comp-functions/useListTablePage'
import {formatCurrency} from '@/utils/formatter'
import useLocalization from '@/comp-functions/utils/useLocalization'
import { ref } from '@vue/composition-api'


export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BPagination,
    BSpinner,
    TableSearchColumn
  },

  setup () {
    const { $t } = useLocalization()
    // Table Handlers
    const tableColumns = ref([
      {
        key: 'code',
        label: 'Code',
        sortable: true,
        search: { type: 'text', value: '' }
      },
      { key: 'date',
        label: 'Date',
        search: { type: 'date', value: '' }
      },
      { key: 'getOffice.name',
        label: $t('globalSingular.branch'),
        search: { type: 'select', value: '', key: 'office_id', url: 'value/getBranch' }
      },
      { key: 'purpose_date',
        label: 'Purpose Date',
        search: { type: 'date', value: '' }
      },
      { key: 'unit',
        label: 'Work Unit',
        search: { type: 'select', value: '', key: 'work_unit_id', url: 'value/work-unit' }
      },
      {
        key: 'request_amount',
        label: 'Request Amount',
        formatter: value => {
          return formatCurrency(value)
        },
        search: { type: 'number', value: 0, key: 'request_amount' }
      },
      {
        key: 'audit',
        label: $t('globalSingular.audit'),
        search: { type: 'text', value: '' }
      }
    ])

    const searchData = async (queryParams) => {
      // loadPage(`transaction/cash-advance/request?search=${datasearch.toUpperCase()}&is_approved=false`)
      customSearchQuery.value = queryParams
      await loadPage()
    }

    const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      focusedSearchField,
      customSearchQuery,
      fetchLists,
      loadPage,
      changePerPage
    } = useListTablePage({ url: 'transaction/cash-advance/request?is_approved=false&' })


    return {
      searchData,
      tableColumns,
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists,
      loadPage,
      changePerPage,
      focusedSearchField
    }
  }
}
</script>
